import store from '@/store';
import decode from 'jwt-decode';
import { checkRouteAccess, checkPlanSubscriptionAccess } from '../utils/role-accees';
import HTTP from '../utils/http-common';
import { getPortalFromPath } from '../utils/tools';

export const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    const publicPaths = ['/signin', '/signup', '/forgotpassword', '/resetpassword'];
    if (!publicPaths.includes(to.path)) {
      next('/signin');
    } else {
      next();
    }
  } else {
    next();
  }
};

export const sleep = (t = 1000) => new Promise((resolve) => setTimeout(resolve, t));
export const accessWithToken = async (to, from, next) => {
  try {
    if (!to.path.match('/art-proofs')) {
      return next();
    }

    let isValidToken = to.query.token && (await HTTP.get(`/virtual-proofs/${to.query.token}/exist`)).data;
    let isUserDispatched;
    const token = sessionStorage.getItem('access_token_4') || localStorage.getItem('access_token');
    try {
      isUserDispatched =
        !(isValidToken || store.getters.isAuthenticated) &&
        token &&
        (await store.dispatch('get_user', decode(token)._id));
    } catch (e) {}
    if (isValidToken || store.getters.isAuthenticated || isUserDispatched) {
      try {
        if (store.getters.isAuthenticated && token) {
          await store.dispatch('get_user', decode(token)._id);
        }
      } catch (e) {
        console.log(e);
      }
      if (store.getters.needToSetupUser) {
        next('/signup');
      } else {
        next();
      }
      return;
    }
  } catch (e) {
    console.log(e);
  }

  next({ path: '/' });
};
export const ifAuthenticated = async (to, from, next, skipCheckSetup) => {
  if (store.getters.isAuthenticated) {
    await store.dispatch(
      'get_user',
      decode(sessionStorage.getItem('access_token_4') || localStorage.getItem('access_token'))._id
    );
    if (!skipCheckSetup && store.getters.needToSetupUser) {
      next('/signup');
    } else {
      next();
    }
    return;
  }
  const redirect = to.fullPath === '/signin' ? null : to.fullPath.replace(/\//g, '-').slice(1);
  next({ path: '/signin', query: { redirect } });
};
export const ifAuthenticatedAndChoose = async (to, from, next) => {
  if (store.getters.isAuthenticated) {
    await store.dispatch(
      'get_user',
      decode(sessionStorage.getItem('access_token_4') || localStorage.getItem('access_token'))._id
    );
    if (store.getters.needToSetupUser) {
      next('/signup');
    } else if ((store.getters.loggedInUser.supplierId && store.getters.loggedInUser.distributorId) || 1) {
      next();
    } else if (store.getters.loggedInUser.supplierId) {
      next('/supplier');
    } else {
      next('/');
    }
    return;
  }
  const redirect = to.fullPath === '/signin' ? null : to.fullPath.replace(/\//g, '-').slice(1);
  next({ path: '/signin', query: { redirect } });
};

export const oauthConsentGuard = async (to, from, next) => {
  if (store.getters.isAuthenticated) {
    await store.dispatch(
      'get_user',
      decode(sessionStorage.getItem('access_token_4') || localStorage.getItem('access_token'))._id
    );
    if (store.getters.needToSetupUser) {
      next('/signup');
      return;
    }
    next();
    return;
  }
  try {
    const nonce = `${to.query.interactionNonce || ''}`.trim();
    if (nonce) sessionStorage.setItem('platform_oauth_interaction_nonce', nonce);
  } catch (e) {}
  next({ path: '/signin', query: { redirect: 'oauth-consent' } });
};

export const isAuthenticatedAndHasDistributor = (user) => {
  return user && user.distributorId;
};

export const hasSubscriptionAccess = async (to, from, next) => {
  const portal = getPortalFromPath(to.path);
  if (!to.meta.requiredTools || checkAccess({ requiredTools: to.meta.requiredTools, portal })) {
    return next();
  }
  if (['/', '/signup', '/admin/users'].includes(from.path)) return next();
  else return next(false);
};

const hasAccessToTools = (plans, requiredTools, planTools) => {
  const toolsArray = Array.isArray(requiredTools) ? requiredTools : requiredTools ? [requiredTools] : [];
  for (const plan of plans) {
    const toolTypes = Object.keys(plan.tools || {});
    for (const toolType of toolTypes) {
      const toolsFromPlan = planTools[toolType.toUpperCase()]?.map((tool) => tool.value) || [];
      const availableToolsFromUser = plan.tools[toolType];
      const filteredAvailableTools = availableToolsFromUser.filter((tool) => toolsFromPlan.includes(tool));
      if (filteredAvailableTools.some((tool) => toolsArray.includes(tool))) {
        return true;
      }
    }
  }
  return false;
};

export const checkAccess = ({ tabName, requiredTools, portal }) => {
  const distributorPlans = store.getters.loggedInUser?.distributorId?.plans;
  const supplierPlans = store.getters.loggedInUser?.supplierId?.plans;

  if (tabName) {
    requiredTools = [tabName.toLowerCase()];
  }

  const toolsArray = Array.isArray(requiredTools) ? requiredTools : requiredTools ? [requiredTools] : [];
  const isSupplierTool = toolsArray.some((tool) => SUPPLIER_PLAN_TOOLS.map((t) => t.value).includes(tool)) && (!portal || portal === 'supplier');
  const plans = isSupplierTool ? supplierPlans || distributorPlans : distributorPlans || supplierPlans;

  if (!plans) return false;

  return hasAccessToTools(plans, toolsArray, PLAN_TOOLS);
};

export const hasAccess = async (to, from, next) => {
  try {
    const roles = store.getters.loggedInUser && JSON.parse(JSON.stringify((store.getters.loggedInUser || []).roles));
    if (checkRouteAccess(to, roles)) {
      return next();
    }
  } catch (e) {
    console.log(e);
  }
  const portal = { path: '/' };
  if (['/', '/dashboard'].includes(to.path)) {
    portal.path = '/choose-portal';
  }
  next(portal);
};
export const hasArtPortalAccess = async (to, from, next) => {
  try {
    if (store.getters.loggedInUser.supplierId?._id || store.getters.loggedInUser.distributorId?._id) {
      return next();
    }
  } catch (e) {
    console.log(e);
  }
  const portal = { path: '/' };
  if (['/', '/dashboard'].includes(to.path)) {
    portal.path = '/choose-portal';
  }
  next(portal);
};
export const isActive = async (to, from, next) => {
  const user = store.getters.loggedInUser;
  if (user && user.isActive) {
    next();
  } else {
    store.dispatch('auth_logout');
    next();
  }
};

export const hasDistributorAccess = async (to, from, next) => {
  const user = store.getters.loggedInUser;
  if (to.path.includes('stores')) {
    if (user.distributorId) {
      next();
    } else {
      next({ path: from.path });
    }
  } else {
    next();
  }
};
const TOOLS = {
  IS_SUPER_ADMIN: 'is_super_admin',
  USER_AS_SUPPLIER: 'user-as-supplier',
  USER_AS_EXECUTIVE: 'is_executive',
  USER_AS_MANAGER: 'is_manager',
  USER_AS_ACCOUNTING: 'is_accounting',
  USER_AS_DISTRIBUTOR_ADMIN: 'is_distributor_admin',
  USER_AS_SALE_ADMIN: 'sales-administrator',
  USER_AS_OUTSIDE_SALE: 'outside-sales',
  USER_AS_SALES: 'is_sales',
  USER_AS_ADMIN: 'admin',
  USER_SHOW_ORDERS_FILTER_SALES_PERSON: 'showOrderFilterSalesPerson',
  CAN_REMOVE_ORDER_DATE: 'can-remove-order-date',
  CAN_DELETE_MANUAL_PAYMENTS: 'can-delete-manual-payments'
};
const ACCOUNT_USERS = ['account-users', 'users'];
const ACCOUNT_DISTRIBUTOR = ['account-my-distributor', 'distributors'];
const ARTS = ['artist', 'menu-art-proofs', 'menu-art-users'];
const ADMIN = ['admin'];
const SUPPLIER_PRODUCTION = [
  'supplier-production-calendar',
  'supplier-production-board',
  'supplier-production-queue',
  'supplier-production-machines'
];
const SUPPLIERS = ['user-as-supplier', ...SUPPLIER_PRODUCTION];
const SUPPLIER_ADS = ['supplier-ads'];
const SUPPLIER_NAV_PAGE_IDS = [
  ...SUPPLIERS,
  'supplier-account-users',
  'supplier-user-as-supplier',
  'supplier-orders',
  'supplier-stores',
  'orders',
  'stores',
  'production-calendar',
  'production-board',
  'production-queue',
  'production-machines'
];
const DASHBOARD_ROLES = ['sales-dashboard', 'executive-dashboard', 'manager-dashboard', 'stores-dashboard'];
const RECONCILE_ROLES = ['accounting'];
const ADMIN_MPOWER_ACCOUNTING = ['menu-admin-reports'];
const ADMIN_MPOWER_ADMIN = ['menu-admin-categories'];
const ADMIN_MPOWER_PRODUCT_MANAGER = ['menu-admin-products', 'menu-admin-stores', 'menu-admin-categories'];
const ADMIN_MPOWER_SUPPLIER = [
  'menu-admin-dashboard',
  'menu-admin-orders',
  'menu-admin-suppliers',
  'menu-admin-stores',
  'menu-admin-users',
  'menu-admin-distributors'
];
const ADMIN_SUPPLIER = ['supplier-account-users'];
const PROMOSTANDARDS = [
  'promostandards-credentials',
  'promostandards-endpoints',
  'promostandards-explorer',
  'promostandards-distributors',
  'promostandards-users'
];

export const ROLES_ACCESS = {
  TOOLS,
  ADMIN_MPOWER_ACCOUNTING,
  ADMIN_MPOWER_ADMIN,
  ADMIN_MPOWER_PRODUCT_MANAGER,
  ADMIN_MPOWER_SUPPLIER,
  DASHBOARD_ROLES,
  ARTS,
  SUPPLIER_PRODUCTION,
  ACCOUNT_DISTRIBUTOR,
  ACCOUNT_USERS,
  ADMIN,
  SUPPLIERS,
  SUPPLIER_ADS,
  SUPPLIER_NAV_PAGE_IDS,
  ADMIN_SUPPLIER,
  PROMOSTANDARDS,
  APPLICATION: [
    ...DASHBOARD_ROLES,
    'orders',
    'customers',
    'products',
    'suppliers',
    'stores',
    'reports',
    ...RECONCILE_ROLES,
    ...ACCOUNT_DISTRIBUTOR,
    ...ACCOUNT_USERS,
    'account-bug-ticket',
    'account-feature-request'
  ]
};

function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log('Fallback: Copying text command was ' + msg);
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
}
export const copyTextToClipboard = function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(
    function () {
      console.log('Async: Copying to clipboard was successful!');
    },
    function (err) {
      console.error('Async: Could not copy text: ', err);
    }
  );
};
export const UOM = ['EA', 'BX', 'CA', 'DZ', 'KT', 'PR', 'PK', 'RL', 'ST', 'SL', 'TH'];
export const LAYERS = ['CMYK', 'Other', 'PMS', 'RGB', 'Thread'];
export const DIMENSION_UOM = ['INCH', 'FOOT', 'METR', 'CMET', 'MILI'];
export const DIMENSION_GEOMETRY = ['Circle', 'Rectangle', 'Other'];
export const ARTWORK_TYPE = ['ProductionReady', 'VirtualProof', 'SupplierArtTemplate', 'NonProductionReady'];
export const TransportMechanism = ['Email', 'Url', 'Ftp', 'ArtworkToFollow'];

const CUSTOMER_PLAN_TOOLS = [
  { value: 'show-customers-section', help: 'Show the Customers section for managing customers, companies, and presentations' },
  { value: 'follow-ups-tab', help: 'Enable access to the Follow Ups tab for managing customer follow-up tasks' },
  { value: 'customers-tab', help: 'Enable access to the Customers tab for managing individual customer records' },
  { value: 'companies-tab', help: 'Enable access to the Companies tab for managing company accounts' },
  {
    value: 'presentations-tab',
    help: 'Enable access to the Presentations tab for creating and managing product presentations'
  },
  { value: 'emails-tab', help: 'Enable access to the Emails tab for email management and communication' },
  { value: 'proofs-tab', help: 'Enable access to the Proofs tab for managing artwork proofs and approvals' },
  { value: 'opportunities-tab', help: 'Enable access to the Opportunities tab for tracking sales opportunities' }
];
const PRODUCT_PLAN_TOOLS = [
  { value: 'show-products-section', help: 'Show the Products section for browsing and managing products' },
  { value: 'promostandards-search-only', help: 'Ability to search PromoStandards only but not tied to a store.' },
  { value: 'add-to-presentation-only', help: 'Viewing product Add to Presentation option only.' },
  { value: 'ai-product-search', help: 'AI chat + semantic search in App Products.' }
  // { value: 'ai-image-product-search', help: 'AI image similarity search in App Products.' }
];

const SUPPLIER_VIEW_LIST_PLAN_TOOLS = [
  { value: 'show-supplier-products-section', help: 'Show the Products section in the supplier portal' },
  { value: 'show-supplier-stores-section', help: 'Show the Stores section in the supplier portal' },
  { value: 'show-supplier-orders-section', help: 'Show the Orders section in the supplier portal' },
  { value: 'show-supplier-dashboard-section', help: 'Show the Dashboard section in the supplier portal' },
  { value: 'show-supplier-reporting-section', help: 'Show the Reporting section in the supplier portal' },
  { value: 'show-supplier-reconciliation-section', help: 'Show the Reconciliation section in the supplier portal' },
  { value: 'show-supplier-proof-section', help: 'Show the Proof section in the supplier portal' },
  { value: 'show-supplier-calendar-section', help: 'Show the Calendar section in the supplier portal' },
  { value: 'show-supplier-board-section', help: 'Show the Board section in the supplier portal' },
  { value: 'show-supplier-machines-section', help: 'Show the Machines section in the supplier portal' },
  {
    value: 'show-supplier-ads-section',
    help: 'Show the Ads section in the supplier portal (product ranking / placements)'
  }
];
const SUPPLIER_APP_PLAN_TOOLS = [
  { value: 'show-suppliers-section', help: 'Show the Suppliers section in the application portal' }
];
const SUPPLIER_PLAN_TOOLS = [
  { value: 'show-suppliers-section', help: 'Show the Suppliers section in the application portal' },
  { value: 'no-editible-pricing', help: "Don't allow pricing to be edited" },
  { value: 'notifications', help: 'Limited to order related status updates. Email only' },
  {
    value: 'integrations',
    help: 'Enable third-party integrations such as Slack, QuickBooks, and other external services'
  },
  { value: 'api-tokens', help: 'Enable API token generation and management for programmatic access' },
  ...SUPPLIER_VIEW_LIST_PLAN_TOOLS
];
const SUPPLIER_PORTAL_PLAN_TOOLS = [
  { value: 'no-editible-pricing', help: "Don't allow pricing to be edited" },
  { value: 'notifications', help: 'Limited to order related status updates. Email only' },
  {
    value: 'integrations',
    help: 'Enable third-party integrations such as Slack, QuickBooks, and other external services'
  },
  { value: 'api-tokens', help: 'Enable API token generation and management for programmatic access' },
  ...SUPPLIER_VIEW_LIST_PLAN_TOOLS
];
const DISTRIBUTOR_PLAN_TOOLS = [
  { value: 'notifications', help: "Limited to art related status updates and customer follow up's.  Email only" },
  {
    value: 'integrations',
    help: 'Enable third-party integrations such as Slack, QuickBooks, and other external services'
  },
  { value: 'request-new-domain', help: 'Allow requesting custom domains for distributor stores' },
  {
    value: 'vectorizer-ai',
    help: 'Enable AI-powered vectorization tools for converting raster images to vector format'
  },
  { value: 'api-tokens', help: 'Enable API token generation and management for programmatic access' },
  { value: 'ai-mockups', help: 'Enable AI mockup generation for presentations' },
  { value: 'ai-chat', help: 'Enable the AI Chat assistant for this distributor' }
];
const REPORTING_PLAN_TOOLS = [
  { value: 'show-reporting-section', help: 'Show the Reporting section for accessing reports and analytics' }
];
const ORDER_PLAN_TOOLS = [
  { value: 'show-order-section', help: 'Show the Orders section for managing and viewing orders' }
];
const STORE_PLAN_TOOLS = [
  { value: 'show-store-section', help: 'Show the Store section for managing store settings and configuration' },
  { value: 'show-product-feed-section', help: 'Show the Product Feed section for managing product data feeds' },
  { value: 'show-reviews-section', help: 'Show the Reviews section for managing product reviews' },
  { value: 'show-fulfillment-section', help: 'Show the Fulfillment section for order fulfillment management' },
  { value: 'show-single-sign-on-section', help: 'Show the Single Sign-On section for SSO configuration' },
  { value: 'show-procurement-section', help: 'Show the Procurement section for procurement management' },
  { value: 'show-analytics-section', help: 'Show the Analytics section for store analytics and insights' }
];
const DASHBOARD_PLAN_TOOLS = [
  { value: 'show-dashboard-section', help: 'Show the Dashboard section for viewing key metrics and overview' }
];
const RECONCILLIATION_PLAN_TOOLS = [
  { value: 'show-reconcilliation-section', help: 'Show the Reconciliation section for financial reconciliation' }
];

const FORUM_PLAN_TOOLS = [{ value: 'show-forum-section', help: 'Show the Forum section for community discussions' }];
const PROOF_PLAN_TOOLS = [{ value: 'show-proof-section', help: 'Show the Proof section for managing artwork proofs' }];
const PRODUCTION_PLAN_TOOLS = [
  { value: 'show-production-portal', help: 'Show the Production portal for production management' }
];
const PROMOSTANDARDS_PLAN_TOOLS = [
  { value: 'show-promostandards-portal', help: 'Show the PromoStandards portal for accessing PS data and endpoints' }
];

export const PLAN_TOOLS = {
  CUSTOMER: CUSTOMER_PLAN_TOOLS,
  PRODUCT: PRODUCT_PLAN_TOOLS,
  SUPPLIER: SUPPLIER_PLAN_TOOLS,
  SUPPLIER_APP: SUPPLIER_APP_PLAN_TOOLS,
  SUPPLIER_PORTAL: SUPPLIER_PORTAL_PLAN_TOOLS,
  REPORTING: REPORTING_PLAN_TOOLS,
  DISTRIBUTOR: DISTRIBUTOR_PLAN_TOOLS,
  ORDER: ORDER_PLAN_TOOLS,
  STORE: STORE_PLAN_TOOLS,
  DASHBOARD: DASHBOARD_PLAN_TOOLS,
  RECONCILLIATION: RECONCILLIATION_PLAN_TOOLS,
  FORUM: FORUM_PLAN_TOOLS,
  PROOF: PROOF_PLAN_TOOLS,
  PROMOSTANDARDS: PROMOSTANDARDS_PLAN_TOOLS
};

export const SUPPLIER_STATUS = [
  { label: 'Production', val: 3, class: 'badge-success', tooltip: `Products available on stores` },
  { label: 'Pending', val: 2, class: 'badge-warning', tooltip: `Connected to this supplier, but their products are not approved for stores by default` },
  { label: 'No Credentials', val: 1, class: 'badge-danger', tooltip: `Missing PS cred` },
  { label: 'Credentials Requested', val: 4, class: 'badge-danger', tooltip: `Credentials Requested` },
  { label: 'Blocked', val: 5, class: 'badge-danger', tooltip: `Blocked` }
];
export const CUSTOMER_RANK = [
  { value: 'A' },
  { value: 'B' },
  { value: 'C' },
  { value: 'D' },
  { value: 'E' },
  { value: 'F' }
];

export { PRECISION as ROUND_PARAMS } from '@mtntop/utils/shared/helpers/money';

export const LOCALIZATION_COUNTRY = ['US', 'CA'];

export const refTypes = [
  {
    type: 'input',
    label: 'Input'
  },
  {
    type: 'checkbox',
    label: 'Checkbox'
  },
  {
    type: 'textarea',
    label: 'Text Area'
  },
  {
    type: 'select',
    label: 'Drop Down'
  },
  {
    type: 'upload',
    label: 'File Upload'
  }
];
export const distributoPlanNavBar = {
  methods: {
    modifiedNavbar(navbar) {
      return navbar.map((navgroup) => {
        const clonedNavgroup = { ...navgroup };

        clonedNavgroup.items = navgroup.items.map((navitem) => {
          if (!navitem.requiredTools) {
            return navitem;
          }
          if (checkAccess({ requiredTools: navitem.requiredTools, portal: this.portal })) {
            return navitem;
          }
          return {
            popover: this.toolTip,
            iconDisabled: 'text-muted position-relative',
            upgradeIconClass: 'fas fa-circle fa-xs text-primary ml-1 position-absolute',
            ...navitem
          };
        });
        return clonedNavgroup;
      });
    }
  }
};
